import React from 'react';
import { EditorView } from '@codemirror/view';
import { Compartment } from '@codemirror/state';
import { createEditorView, replaceWholeDoc } from '@ui-schema/kit-codemirror/createEditorView';
export const useCodeMirror = (onChange, value = '', extensions, effects, containerRef, onExternalChange = replaceWholeDoc, onViewLifecycle) => {
  var _effects;

  const lastValueRef = React.useRef(value);
  const onChangeRef = React.useRef(undefined);
  const [editor, setEditor] = React.useState(undefined);
  onChangeRef.current = onChange;
  const readOnlyCompartment = React.useRef(new Compartment());
  React.useLayoutEffect(() => {
    const editor = createEditorView(lastValueRef, [...(extensions || []), readOnlyCompartment.current.of(EditorView.editable.of(Boolean(onChangeRef.current)))], onChangeRef);

    if (containerRef) {
      var _containerRef$current;

      (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.append(editor.dom);
    }

    setEditor(editor);
    onViewLifecycle === null || onViewLifecycle === void 0 ? void 0 : onViewLifecycle(editor);
    return () => {
      onViewLifecycle === null || onViewLifecycle === void 0 ? void 0 : onViewLifecycle(editor, true);
      editor === null || editor === void 0 ? void 0 : editor.destroy();
      setEditor(undefined);
    };
  }, [containerRef, extensions, onViewLifecycle]);
  React.useEffect(() => {
    if (!editor) return;
    editor.dispatch({
      effects: readOnlyCompartment.current.reconfigure(EditorView.editable.of(Boolean(onChange)))
    });
  }, [editor, onChange]);
  React.useLayoutEffect(() => {
    if (!editor) return;

    if (lastValueRef.current !== value) {
      const textA = editor.state.doc.toString();
      const textB = value;
      onExternalChange(editor, textB, textA);
      lastValueRef.current = textB;
    } else {
      lastValueRef.current = value;
    }
  }, [value, editor, onExternalChange, containerRef]);
  effects = ((_effects = effects) === null || _effects === void 0 ? void 0 : _effects.length) === 0 ? undefined : effects;
  React.useLayoutEffect(() => {
    if (!editor && effects) {
      console.error('received effects but editor is not ready', effects);
      return;
    }

    if (!effects || !editor) return;
    effects.forEach(effect => {
      effect(editor);
    });
  }, [effects, editor]);
  return editor;
};